import React from 'react';
import PropTypes from 'prop-types';

export const ParagraphWrapper = Component => {
  const wrapper = props => {
    const { data, type, id } = props;
    const paragraphType = data?.type || type;
    const paragraphId = data?.id || id;

    if (paragraphType && paragraphId) {
      return (
        <div
          className={`module--type-${paragraphType} module--id-${paragraphId}`}
        >
          <Component {...props} />
        </div>
      );
    }
    return <Component {...props} />;
  };

  return wrapper;
};

ParagraphWrapper.propTypes = {
  Component: PropTypes.element
};
